import authHeader from '@/api/auth-header'
import axios from 'axios'

export default {
  async getEvents() {
    const res = await axios.get('/get_all_events_admin/')
    return res.data
  },

  async getEventsDashboard(params = {}) {
    const res = await axios.get('/events_dashboard/', {
      headers: authHeader(),
      params,
    })
    return res.data
  },

  async getEventsDashboardDetails(params = {}) {
    const res = await axios.get('/events_dashboard/details/', {
      headers: authHeader(),
      params,
    })
    return res.data
  },

  async getEventDataById(eventId) {
    const res = await axios.get(`/get_event_data_by_id/?event_id=${eventId}`, {
      headers: authHeader(),
    })
    return res.data
  },

  async getReservationListByEventId(params) {
    const res = await axios.post('/get_events_by_id/', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async getReservationByUuid(params) {
    const res = await axios.post('/get_reservation_by_uuid/', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async getReservationByOrderId(params) {
    const res = await axios.post('/get_reservation_by_order_id/', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async payCashInvoiceWithReceipt(params) {
    const res = await axios.post('/pay_cash_invoice_with_receipt/', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async checkReceipt(invoiceId) {
    const res = await axios.get('/check_receipt/', {
      params: { invoice_id: invoiceId },
      headers: authHeader(),
    })
    return res.data
  },

  async getReservation(params) {
    const res = await axios.post('/get_reservation_admin/', params, {
      headers: authHeader(),
    })
    return res.data
  },
  async updateReservation(params) {
    const res = await axios.post('/update_reservation_admin/', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async checkInvoice(params) {
    const res = await axios.post('/check_invoice_reservation/', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async deleteInvoice(params) {
    const res = await axios.post('/delete_invoice/', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async updateInvoice(params) {
    const res = await axios.post('/update_invoice/', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async checkPay(params) {
    const res = await axios.post('/check_pay/', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async updateInvoicePayStatus(params) {
    const res = await axios.post('/update_invoice_pay_status/', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async getFreeEventRooms(params) {
    const res = await axios.post('/get_free_event_rooms/', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async AddReservation(params) {
    const res = await axios.post('/add_reservation/', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async getRoomForEvents(params) {
    const res = await axios.post('/get_room_for_events/', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async getUsers() {
    const res = await axios.get('/get_users/', {
      headers: authHeader(),
    })
    return res.data
  },

  async createCashInvoice(params) {
    const res = await axios.post('/create_cash_invoice/', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async handoverCashInvoices(params) {
    const res = await axios.post('/handover_cash_invoices/', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async deleteReservation(params) {
    const res = await axios.post('/delete_reservation/', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async deleteRoom(params) {
    const res = await axios.post('/delete_room_in_reservation_admin/', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async reservationSuccess(params) {
    const res = await axios.post('/reservation_success/', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async getPackagesByEventId(params) {
    const res = await axios.post('/get_packages_by_event_id/', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async getPackageById(params) {
    const res = await axios.post('/get_package_by_id/', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async updatePackageById(params) {
    const res = await axios.post('/update_package_by_id/', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async getEventPeopleByDays(params) {
    const res = await axios.post('/get_event_people_by_days/', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async getEventPeopleList(params) {
    const res = await axios.post('/get_event_people/', params, {
      headers: authHeader(),
    })
    return res.data
  },

  // Обновленная ручка для запроса списка участников события
  async getEventPeopleData(params) {
    const res = await axios.get('/event_people_data', {
      params,
      headers: authHeader(),
    })
    return res.data
  },
  async changeEventPeopleSportType(params) {
    const res = await axios.post('/change_event_people_sport_type/', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async changeRoomAdmin(params) {
    const res = await axios.post('/change_room_admin/', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async getRoomListByEventIdAndRoomType(params) {
    const res = await axios.post('/get_room_list_by_event_id_and_room_type/', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async resettleAdmin(params) {
    const res = await axios.post('/resettle_admin/', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async confirmReservation(params) {
    const res = await axios.post('/confirm_reservation/', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async synchEventsRacketcamp(params) {
    const res = await axios.post('/synch_events_racketcamp/', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async addBonusTransaction(params) {
    const res = await axios.post('/create_bonuses_for_event/', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async getClients(params) {
    const res = await axios.post('/get_clients/', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async getBonusTransaction() {
    const res = await axios.get('/get_bonuses_transaction/')
    return res.data
  },

  async getBonusesTransactionByReservationUuids(reservation_uuids) {
    const res = await axios.post(
      '/get_bonuses_transaction/',
      { reservation_uuids },
      { headers: authHeader() },
    )
    return res.data
  },

  async createBonusTransaction(params) {
    const res = await axios.post('/create_bonus_transaction/', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async writeOffBonuses(params) {
    const res = await axios.post('/write_off_bonuses/', params, {
      headers: authHeader(),
    })
    return res.data
  },
  async writeOffBonusesWithComment(params) {
    const res = await axios.post('/write_off_bonuses_with_comment/', params, {
      headers: authHeader(),
    })
    return res.data
  },

  // PROMOCODE

  async promoCodeAdd(params) {
    const res = await axios.post('/promo_code/', params, {
      headers: authHeader(),
    })
    return res.data
  },
  async promoCodeDelete(params) {
    const res = await axios.delete(
      '/promo_code/',
      { data: params },
      {
        headers: authHeader(),
      },
    )
    return res.data
  },

  // СЕРТИФИКАТЫ
  async getActiveProject() {
    const res = await axios.get('/certs/projects', {
      headers: authHeader(),
    })
    return res.data
  },
  async getCerts(params) {
    const res = await axios.post('/certs/get', params, {
      headers: authHeader(),
    })
    return res.data
  },
  async getCertsList(config) {
    const res = await axios.get('/certs/list', config, {
      headers: authHeader(),
    })
    return res.data
  },
  async createCert(params) {
    const res = await axios.post('/certs/create', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async cancelCert(params) {
    const res = await axios.post('/certs/cancel', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async archivedCert(params) {
    const res = await axios.post('/certs/archived', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async createBadmintonistWithoutBill(params) {
    const res = await axios.post('/certs/create_badmintonist_without_bill', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async createBadmintonistWithBill(params) {
    const res = await axios.post('/certs/create_badmintonist_with_bill', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async msRetailDemandData(params) {
    const res = await axios.post('/certs/ms_retail_demand_data', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async activateСertBadmintonist(params) {
    const res = await axios.post('/certs/activate_badmintonist', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async msDemandForCertTemp(params) {
    const res = await axios.post('/certs/ms_demand_for_cert_temp', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async checkCertOperation(params) {
    const res = await axios.post('/certs/check_cert_operation', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async createSpaceXbadmBill(params) {
    const res = await axios.post('/certs/create_space_xbadm_bill', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async getCertHistory(params) {
    const res = await axios.post('/certs/get_cert_history', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async paperComment(params) {
    const res = await axios.post('/certs/paper_comment', params, {
      headers: authHeader(),
    })
    return res.data
  },

  // CLUB PLAYER
  async createSpaceXbadmNoBill(params) {
    const res = await axios.post('/certs/create_space_xbadm_no_bill', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async giftRequests(config) {
    const res = await axios.get('/club_player/gift_requests', config, {
      headers: authHeader(),
    })
    return res.data
  },
  async completeGiftRequest(params) {
    const res = await axios.post('/club_player/complete_gift_request', params, {
      headers: authHeader(),
    })
    return res.data
  },
  async deleteGiftRequest(params) {
    const res = await axios.post('/club_player/delete_gift_request', params, {
      headers: authHeader(),
    })
    return res.data
  },
  async getClubPlayerClients(config) {
    const res = await axios.get('/club_player/users_points', config, {
      headers: authHeader(),
    })
    return res.data
  },
  async getClubPlayerClientHistory(userPk) {
    const res = await axios.get(`/club_player/history?user_pk=${userPk}`, {
      headers: authHeader(),
    })
    return res.data
  },
  /**
   * GET /club_player/loyalty_status — текущий статус и привилегии участника.
   * Query: user_id (не user_pk). Для истории по кварталам — getClubPlayerLoyaltyYearlyStatuses.
   */
  async getClubPlayerLoyaltyStatus(userIdOrParams) {
    const params = typeof userIdOrParams === 'object' && userIdOrParams !== null
      ? { user_id: userIdOrParams.user_id }
      : { user_id: userIdOrParams }
    if (params.user_id == null) {
      throw new Error('getClubPlayerLoyaltyStatus: user_id is required')
    }
    const res = await axios.get('/club_player/loyalty_status', {
      params,
      headers: authHeader(),
    })
    return res.data
  },

  /**
   * GET /club_player/loyalty_yearly_statuses — статус участника по кварталам за год.
   * Query: user_id (обяз.), year (опц., по умолчанию текущий).
   * Статус квартала Q = баллы (UP), заработанные в Q-1, и пороги квартала Q.
   */
  async getClubPlayerLoyaltyYearlyStatuses({ user_id, year } = {}) {
    if (user_id == null) {
      throw new Error('getClubPlayerLoyaltyYearlyStatuses: user_id is required')
    }
    const params = { user_id }
    if (year != null && year !== '') {
      params.year = year
    }
    const res = await axios.get('/club_player/loyalty_yearly_statuses', {
      params,
      headers: authHeader(),
    })
    return res.data
  },
  // POST /club_player/adjust_loyalty_privilege — тело: { user_pk, privilege_type, delta }.
  async adjustClubPlayerLoyaltyPrivilege(params) {
    const res = await axios.post('/club_player/adjust_loyalty_privilege', params, {
      headers: authHeader(),
    })
    return res.data
  },
  async ClubPlayerTopupPoints(params) {
    const res = await axios.post('/club_player/topup_points', params, {
      headers: authHeader(),
    })
    return res.data
  },
  /**
   * GET /club_player/statistics — сводная статистика программы (админ).
   * Query: date_from + date_to (вместе) или прошлый квартал по умолчанию;
   * user_id (опц.) — фильтр по клиенту (счётчики tier: 0 или 1).
   * Поля: loyalty_tiers, loyalty_tiers_by_period, gifts, free_cancelings, penalties.
   */
  async getClubPlayerStatistics(params = {}) {
    const res = await axios.get('/club_player/statistics', {
      headers: authHeader(),
      params,
    })
    return res.data
  },

  /**
   * GET /club_player/statistics/details — списки записей для drill-down.
   * section: gifts | free_cancelings | penalties (+ gift_id, record_type, penalty_tier).
   * user_id (опц.) — только записи выбранного клиента.
   */
  async getClubPlayerStatisticsDetails(params = {}) {
    const res = await axios.get('/club_player/statistics/details', {
      headers: authHeader(),
      params,
    })
    return res.data
  },

  // PROMOCODES

  async getPromocodes(params) {
    const res = await axios.post('/get_promocodes', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async getAllEvents() {
    const res = await axios.get('/get_all_events/')
    return res.data
  },

  async createPromocodes(params) {
    const res = await axios.post('/create_promocode', params, {
      headers: authHeader(),
    })
    return res.data
  },

  // TAX DEDUCTION
  async getTaxDeduction(params) {
    const res = await axios.post('/sales/tax_deduction_certs', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async completeTaxDeduction(params) {
    const res = await axios.post('/sales/complete_tax_deduction', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async addManualOrder(params) {
    const res = await axios.post('/sales/add_manual_order', params, {
      headers: authHeader(),
    })
    return res.data
  },
  async updateTaxDeductionCert(params) {
    const res = await axios.post('/sales/update_tax_deduction_cert', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async uploadTaxDeductionFile(params) {
    const res = await axios.post('/sales/upload_tax_deduction_file', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async ordersTaxDeduction(params) {
    const res = await axios.post('/sales/orders_tax_deduction', params, {
      headers: authHeader(),
    })
    return res.data
  },

  // TRAINER OFFER
  async sendTrainerOffer(params) {
    const res = await axios.post('send_trainer_offer', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async getTrainerOffer(params) {
    const res = await axios.get('trainer_offer', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async addTrainerOffer(params) {
    const res = await axios.post('trainer_offer', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async editTrainerOffer(params) {
    const res = await axios.patch('trainer_offer', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async trainerOfferAnswer(params) {
    const res = await axios.post('trainer_offer_answer', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async deleteTrainerOfferAnswer(params) {
    const res = await axios.delete('trainer_offer', params, {
      headers: authHeader(),
    })
    return res.data
  },

  // Обратная связь

  async getUsersFeedback(params) {
    const res = await axios.get('/reports/users_feedback/', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async getUsersFeedbackByUuid(uuid, params) {
    const res = await axios.get(`/reports/users_feedback/${uuid}/`, params, {
      headers: authHeader(),
    })
    return res.data
  },

  async deleteUserFeedback(uuid) {
    const res = await axios.delete(`/reports/users_feedback/${uuid}/`, {
      headers: authHeader(),
    })
    return res.data
  },

  // Шкафчики Space ВДНХ

  async searchClient(params) {
    const res = await axios.post('/yclients/search_client', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async generateQRCode(params) {
    const res = await axios.post('/userdata/locker_qr', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async manualQRCode(params) {
    const res = await axios.post('/userdata/locker_qr_manual', params, {
      headers: authHeader(),
      responseType: 'blob',
    })
    return res.data
  },

  // Обратная связь для спортсменов сборов
  async createFeedback(params) {
    const res = await axios.post('/feedback/feedback_event_people/', params, {
      headers: authHeader(),
    })
    return res.data
  },
  async getAllFeedbacks() {
    const res = await axios.get('/feedback/feedback_event_people/', {
      headers: authHeader(),
    })
    return res.data
  },
  async getFeedbackById(id) {
    const res = await axios.get(`/feedback/feedback_event_people/${id}/`, {
      headers: authHeader(),
    })
    return res.data
  },
  async updateFeedback(id, params) {
    const res = await axios.put(`/feedback/feedback_event_people/${id}/`, params, {
      headers: authHeader(),
    })
    return res.data
  },
  async patchFeedback(id, params) {
    const res = await axios.patch(`/feedback/feedback_event_people/${id}/`, params, {
      headers: authHeader(),
    })
    return res.data
  },
  async deleteFeedback(id) {
    const res = await axios.delete(`/feedback/feedback_event_people/${id}/`, {
      headers: authHeader(),
    })
    return res.data
  },
  async getEventPeopleWithFeedback(uuid) {
    const res = await axios.get(`/feedback/feedback_event_people/by_event/${uuid}/`, {
      headers: authHeader(),
    })
    return res.data
  },

  async sendfeedBackEmail(params) {
    const res = await axios.post('/feedback/feedback_event_people/send_emails/', params, {
      headers: authHeader(),
    })
    return res.data
  },

  // Reports
  async getCompanyReport(params) {
    const res = await axios.post('/reports/company_report', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async getSalaryDict(params) {
    const res = await axios.get('/reports/salary_dict', params, {
      headers: authHeader(),
    })
    return res.data
  },
  async getSalaryDictHealth(params) {
    const res = await axios.get('/reports/salary_dict_health', params, {
      headers: authHeader(),
    })
    return res.data
  },
  async updateSalaryDict(params) {
    const res = await axios.patch('/reports/salary_dict', params, {
      headers: authHeader(),
    })
    return res.data
  },
  async createSalaryDict(params) {
    const res = await axios.post('/reports/salary_dict', params, {
      headers: authHeader(),
    })
    return res.data
  },

  // async copySalaryDict(params) {
  //   const res = await axios.post('/reports/copy_salary_dict', params, {
  //     headers: authHeader(),
  //   })
  //   return res.data
  // },
  async deleteSalaryDict(params) {
    const res = await axios.delete('/reports/salary_dict', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async getStaffByBranchId(params) {
    const res = await axios.get('/reports/staff', params, {
      headers: authHeader(),
    })
    return res.data
  },
  async createStaffSalaryReport(params) {
    const res = await axios.post('/reports/staff_salary_report', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async getStaffSalaryReports(params) {
    const res = await axios.get('/reports/staff_salary_reports', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async getStaffSalaryReport(params) {
    const res = await axios.get('/reports/staff_salary_report', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async getStaffSalaryReportHealth(params) {
    const res = await axios.get('/reports/staff_salary_report_health', params, {
      headers: authHeader(),
    })
    return res.data
  },

  // Персональные тренировки

  async getPersonalTrainingsReports(params) {
    const res = await axios.get('/reports/personal_trainings_reports', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async createPersonalTrainingsReport(data) {
    try {
      const response = await axios.post('/reports/personal_trainings_report', data, {
        headers: authHeader(),
      })
      return response
    } catch (error) {
      console.error('API Error:', error)
      throw error
    }
  },

  async getPersonalTrainingsReport(reportId) {
    try {
      const response = await axios.get('/reports/personal_trainings_report', {
        params: { id: reportId },
        headers: authHeader(),
      })

      return response.data || {
        report_status: 'PROCESSING',
        message: 'Данные отчета еще не готовы',
      }
    } catch (error) {
      console.error('API Error:', error)
      throw error
    }
  },

    async getSalaryDictPersonal(params) {
    const res = await axios.get('/reports/salary_dict_personal', params, {
      headers: authHeader(),
    })
    return res.data
  },

  // Отчет о загрузке кортов
  async getCourtsOccupancyReports(params) {
    const res = await axios.get('/reports/courts_occupancy_reports', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async getCourtsOccupancyReport(params) {
    const res = await axios.get('/reports/courts_occupancy_report', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async createCourtsOccupancyReport(params) {
    const res = await axios.post('/reports/courts_occupancy_report', params, {
      headers: authHeader(),
    })
    return res.data
  },
  async getSettlementsReports(params) {
    const res = await axios.get('/reports/settlements_reports', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async getSettlementsReport(id) {
    const res = await axios.get(`/reports/settlements_report?id=${id}`, params, {
      headers: authHeader(),
    })
    return res.data
  },

  async createSettlementsReport(params) {
    const res = await axios.post('/reports/settlements_report', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async getFinancialReports(params) {
    const res = await axios.get('/reports/financial_reports', {
      headers: authHeader(),
      params: params || {},
    })
    return res.data
  },

  async getFinancialReport(reportId) {
    const res = await axios.get(`/reports/financial_reports/${reportId}`, {
      headers: authHeader(),
    })
    return res.data
  },

  async createFinancialReport(params) {
    const res = await axios.post('/reports/financial_reports', params, {
      headers: authHeader(),
    })
    return res.data
  },

  // спецификация
  async getIndividualsList(params) {
    const res = await axios.get('/reports/individuals_list', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async getСontractByIpAndAtaff(params) {
    const res = await axios.get('/reports/contract', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async getSalarSpec(params) {
    const res = await axios.get('/reports/salary_spec', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async createSalarSpec(params) {
    const res = await axios.post('/reports/salary_spec', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async deleteSalarSpec(params) {
    const res = await axios.delete('/reports/salary_spec', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async getSalarySpecsList(params) {
    const res = await axios.get('/reports/salary_specs_list', params, {
      headers: authHeader(),
    })
    return res.data
  },

  // спецификация персоналки
  async getSalarSpecPersonal(params) {
    const res = await axios.get('/reports/salary_spec_personal', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async createSalarSpecPersonal(params) {
    const res = await axios.post('/reports/salary_spec_personal', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async deleteSalarSpecPersonal(params) {
    const res = await axios.delete('/reports/salary_spec_personal', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async getSalarySpecsListPersonal(params) {
    const res = await axios.get('/reports/salary_specs_personal_list', params, {
      headers: authHeader(),
    })
    return res.data
  },

  // Льготы (admin / benefits API)
  async getUserBenefits(params) {
    const res = await axios.get('/benefits/user_benefits', {
      headers: authHeader(),
      params: params || {},
    })
    return res.data
  },

  async getUserBenefitsList(params) {
    const res = await axios.get('/benefits/user_benefits_admin', {
      headers: authHeader(),
      params: params || {},
    })
    return res.data
  },

  async getUserBenefitDetail(benefitId) {
    const res = await axios.get(`/benefits/user_benefits/${benefitId}/`, {
      headers: authHeader(),
    })
    return res.data
  },

  async updateUserBenefit(benefitId, payload) {
    const res = await axios.patch(`/benefits/user_benefits/${benefitId}/update/`, payload, {
      headers: authHeader(),
    })
    return res.data
  },

  async getBenefitRequests(params) {
    const res = await axios.get('/benefits/benefit_requests', {
      headers: authHeader(),
      params: params || {},
    })
    return res.data
  },

  async approveBenefitRequest(payload) {
    const res = await axios.post('/benefits/benefit_request_approve', payload, {
      headers: authHeader(),
    })
    return res.data
  },

  async rejectBenefitRequest(payload) {
    const res = await axios.post('/benefits/benefit_request_reject', payload, {
      headers: authHeader(),
    })
    return res.data
  },

  async deleteBenefitRequest(requestId) {
    const res = await axios.delete(`/benefits/benefit_request_delete/${requestId}/`, {
      headers: authHeader(),
    })
    return res.data
  },

  async createUserBenefit(payload) {
    const res = await axios.post('/benefits/create_user_benefit', payload, {
      headers: authHeader(),
    })
    return res.data
  },

  async deleteUserBenefit(benefitId) {
    const res = await axios.delete(`/benefits/delete_user_benefit/${benefitId}/`, {
      headers: authHeader(),
    })
    return res.data
  },

  async getBenefitLogs(params) {
    const res = await axios.get('/benefits/benefit_logs', {
      headers: authHeader(),
      params: params || {},
    })
    return res.data
  },

  async getBenefitCategories() {
    const res = await axios.get('/benefits/benefit_categories', {
      headers: authHeader(),
    })
    return res.data
  },

  async getBenefitRules(params) {
    const res = await axios.get('/benefits/benefit_rules', {
      headers: authHeader(),
      params: params || {},
    })
    return res.data
  },

  async searchBenefitUsers(params) {
    const res = await axios.get('/benefits/benefit_users_search', {
      headers: authHeader(),
      params: params || {},
    })
    return res.data
  },

  async createBenefitRequest(payload) {
    const res = await axios.post('/benefits/request', payload, {
      headers: authHeader(),
    })
    return res.data
  },

  // --- Услуги мероприятий (каталог) ---

  async getEventServices(params) {
    const res = await axios.post('/get_event_services/', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async createEventService(params) {
    const res = await axios.post('/create_event_service/', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async updateEventService(params) {
    const res = await axios.post('/update_event_service/', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async deleteEventService(params) {
    const res = await axios.post('/delete_event_service/', params, {
      headers: authHeader(),
    })
    return res.data
  },

  // --- Услуги в брони ---

  async addReservationService(params) {
    const res = await axios.post('/add_reservation_service/', params, {
      headers: authHeader(),
    })
    return res.data
  },

  async deleteReservationService(params) {
    const res = await axios.post('/delete_reservation_service/', params, {
      headers: authHeader(),
    })
    return res.data
  },

  // --- Бронь без номера ---

  async addServiceReservation(params) {
    const res = await axios.post('/add_service_reservation/', params, {
      headers: authHeader(),
    })
    return res.data
  },

  // --- Ручная итоговая сумма ---

  async setReservationTotal(params) {
    const res = await axios.post('/set_reservation_total/', params, {
      headers: authHeader(),
    })
    return res.data
  },

  // --- Мягкая отмена ---

  async cancelReservation(params) {
    const res = await axios.post('/cancel_reservation/', params, {
      headers: authHeader(),
    })
    return res.data
  },

  // --- Создание клиента из админки ---

  async createClientAdmin(params) {
    const res = await axios.post('/create_client_admin/', params, {
      headers: authHeader(),
    })
    return res.data
  },

  // Кэшбэк тренеров
  async getCoachCashbackCoaches(params) {
    const res = await axios.get('/benefits/coach_cashback/coaches', {
      headers: authHeader(),
      params: params || {},
    })
    return res.data
  },

  async setCoachCashbackContract(payload) {
    const res = await axios.post('/benefits/coach_cashback/contract', payload, {
      headers: authHeader(),
    })
    return res.data
  },

  async getCoachCashbackTrainings(params) {
    const res = await axios.get('/benefits/coach_cashback/trainings', {
      headers: authHeader(),
      params: params || {},
    })
    return res.data
  },

  async getCoachCashbackSummary(params) {
    const res = await axios.get('/benefits/coach_cashback/summary', {
      headers: authHeader(),
      params: params || {},
    })
    return res.data
  },

  async postCoachCashbackTopup(payload) {
    const res = await axios.post('/benefits/coach_cashback/topup', payload, {
      headers: authHeader(),
    })
    return res.data
  },

  async getCoachCashbackTopups(params) {
    const res = await axios.get('/benefits/coach_cashback/topups', {
      headers: authHeader(),
      params: params || {},
    })
    return res.data
  },

  async getCoachCashbackTopupDetail(topupId) {
    const res = await axios.get(`/benefits/coach_cashback/topups/${topupId}`, {
      headers: authHeader(),
    })
    return res.data
  },

  async createCoachCashbackAdjustment(payload) {
    const res = await axios.post('/benefits/coach_cashback/adjustments', payload, {
      headers: authHeader(),
    })
    return res.data
  },

  async deleteCoachCashbackAdjustment(adjustmentId) {
    const res = await axios.delete(
      `/benefits/coach_cashback/adjustments/${adjustmentId}`,
      {
        headers: authHeader(),
      },
    )
    return res.data
  },

  async getCoachCashbackPeriods(params) {
    const res = await axios.get('/benefits/coach_cashback/periods', {
      headers: authHeader(),
      params: params || {},
    })
    return res.data
  },

  async putCoachCashbackPeriods(payload) {
    const res = await axios.put('/benefits/coach_cashback/periods', payload, {
      headers: authHeader(),
    })
    return res.data
  },

  async getCoachCashbackStatuses() {
    const res = await axios.get('/benefits/coach_cashback/statuses', {
      headers: authHeader(),
    })
    return res.data
  },

  async putCoachCashbackStatuses(payload) {
    const res = await axios.put('/benefits/coach_cashback/statuses', payload, {
      headers: authHeader(),
    })
    return res.data
  },

  async getAnalyticsFunnel(params) {
    const res = await axios.get('/analytics/funnel/', {
      headers: authHeader(),
      params: params || {},
    })
    return res.data
  },

  async getAnalyticsSources(params) {
    const res = await axios.get('/analytics/sources/', {
      headers: authHeader(),
      params: params || {},
    })
    return res.data
  },

  async getAnalyticsCampaigns(params) {
    const res = await axios.get('/analytics/campaigns/', {
      headers: authHeader(),
      params: params || {},
    })
    return res.data
  },

  async getAnalyticsOptions() {
    const res = await axios.get('/analytics/options/', {
      headers: authHeader(),
    })
    return res.data
  },

  async getAnalyticsCustomers(params) {
    const res = await axios.get('/analytics/customers/', {
      headers: authHeader(),
      params: params || {},
    })
    return res.data
  },

  async getAnalyticsCustomer(customerId) {
    const res = await axios.get(`/analytics/customers/${customerId}/`, {
      headers: authHeader(),
    })
    return res.data
  },

  async getRenewalOffersAdmin(params) {
    const res = await axios.get('/sales/renewal_offers_admin/', {
      headers: authHeader(),
      params: params || {},
    })
    return res.data
  },

  async getRenewalOffersFunnel(params) {
    const res = await axios.get('/sales/renewal_offers_admin/funnel/', {
      headers: authHeader(),
      params: params || {},
    })
    return res.data
  },

}
